// src/lib/intake/intakeAnalytics.js
//
// Ticket 061 (Advisor Intake I4). The only place intake PostHog event names
// live. Properties are screen ids, a boolean, and error codes only: never an
// answer (so no move-date branch or date), never an email, name or count.
// Autocapture stays off. Known interaction (not changed here): AuthContext
// calls posthog.identify(userId, { email }) for every signed-in user.

import posthog from '../posthog'

export const INTAKE_EVENTS = {
  welcomeViewed: 'intake_welcome_viewed',
  screenViewed: 'intake_screen_viewed',
  gateReached: 'intake_gate_reached',
  gatePassed: 'intake_gate_passed',
  resumeRequested: 'intake_resume_requested',
  resumed: 'intake_resumed',
  saveFailed: 'intake_save_failed',
  resultsViewed: 'intake_results_viewed',
  resultsTabViewed: 'intake_results_tab_viewed',
  resultsSaved: 'intake_results_saved',
  calculateFailed: 'intake_calculate_failed',
  shareViewed: 'intake_share_viewed',
  shared: 'intake_shared',
  shareFailed: 'intake_share_failed',
  shareStopped: 'intake_share_stopped',
  advisorClientCreated: 'intake_advisor_client_created',
  advisorClientOpened: 'intake_advisor_client_opened',
  advisorClientRemoved: 'intake_advisor_client_removed',
}

function send(name, props) {
  try { posthog.capture(name, props) } catch { /* analytics must never break the page */ }
}

export const trackWelcomeViewed = (hasPartnerRef) => send(INTAKE_EVENTS.welcomeViewed, { has_partner_ref: !!hasPartnerRef })
export const trackScreenViewed = (screen) => send(INTAKE_EVENTS.screenViewed, { screen })
export const trackGateReached = () => send(INTAKE_EVENTS.gateReached)
export const trackGatePassed = () => send(INTAKE_EVENTS.gatePassed)
export const trackResumeRequested = () => send(INTAKE_EVENTS.resumeRequested)
export const trackResumed = () => send(INTAKE_EVENTS.resumed)
export const trackSaveFailed = (code) => send(INTAKE_EVENTS.saveFailed, { code })

// Ticket 069. Booleans and an error code only: no amounts, no findings, no ids.
export const trackResultsViewed = (hasEstimate, hasGaps) => send(INTAKE_EVENTS.resultsViewed, { has_estimate: !!hasEstimate, has_gaps: !!hasGaps })
export const trackResultsSaved = () => send(INTAKE_EVENTS.resultsSaved)
export const trackCalculateFailed = (code) => send(INTAKE_EVENTS.calculateFailed, { code })
export const trackResultsTabViewed = (tab) => send(INTAKE_EVENTS.resultsTabViewed, { tab })

// Ticket 070. No name, phone, email or advisor name: nothing here, and an error code at most.
export const trackShareViewed = () => send(INTAKE_EVENTS.shareViewed)
export const trackShared = () => send(INTAKE_EVENTS.shared)
export const trackShareFailed = (code) => send(INTAKE_EVENTS.shareFailed, { code })
export const trackShareStopped = () => send(INTAKE_EVENTS.shareStopped)

// Ticket 073. No client name, id or answer: the event alone, nothing attached.
export const trackAdvisorClientCreated = () => send(INTAKE_EVENTS.advisorClientCreated)
export const trackAdvisorClientOpened = () => send(INTAKE_EVENTS.advisorClientOpened)
export const trackAdvisorClientRemoved = () => send(INTAKE_EVENTS.advisorClientRemoved)
